import { defineMeta } from '../../../../define';

export default defineMeta({
  id: 'js-values-strict-equality',
  slug: 'strict-equality',
  title: 'Fix the PIN check',
  type: 'bug-hunt',
  estSeconds: 180,
  contentVersion: 1,
  isGuest: true,
});
